// extracted by mini-css-extract-plugin
module.exports = {"hidden":"join-team-sidebar-callout_hidden_1JF","openNavDrawer":"join-team-sidebar-callout_openNavDrawer_3K0"};